import { clsx } from 'clsx';
import React from 'react';
import '../Button/ButtonBase.js';
import '../utils/defaultSxProp.js';
import { ButtonComponent } from '../Button/Button.js';
import '../TooltipV2/Tooltip.js';
import '../Tooltip/Tooltip.js';
import Link from '../Link/Link.js';
import classes from './Blankslate.module.css.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Blankslate({
  border,
  children,
  narrow,
  spacious,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.Container
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.Blankslate, className),
    "data-border": border,
    "data-narrow": narrow,
    "data-spacious": spacious
  }, children));
}
Blankslate.displayName = "Blankslate";
function Visual({
  children
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: clsx('Blankslate-Visual', classes.Visual)
  }, children);
}
Visual.displayName = "Visual";
function Heading({
  as: Component = 'h2',
  children
}) {
  return /*#__PURE__*/React.createElement(Component, {
    className: clsx('Blankslate-Heading', classes.Heading)
  }, children);
}
Heading.displayName = "Heading";
function Description({
  children
}) {
  return /*#__PURE__*/React.createElement("p", {
    className: clsx('Blankslate-Description', classes.Description)
  }, children);
}
Description.displayName = "Description";
function PrimaryAction({
  children,
  href,
  ...props
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('Blankslate-Action', classes.Action)
  }, /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, props, {
    as: href ? 'a' : 'button',
    href: href,
    variant: "primary"
  }), children));
}
PrimaryAction.displayName = "PrimaryAction";
function SecondaryAction({
  children,
  href
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('Blankslate-Action', classes.Action)
  }, /*#__PURE__*/React.createElement(Link, {
    href: href
  }, children));
}
SecondaryAction.displayName = "SecondaryAction";
var Blankslate$1 = Object.assign(Blankslate, {
  Visual,
  Heading,
  Description,
  PrimaryAction,
  SecondaryAction
});

export { Blankslate$1 as default };
